module.exports = __webpack_public_path__ + "img/lp-pneumonia.6bf27306.svg";